import React, { useState } from 'react'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid'
import { Form, FormInputProps, InputProps } from 'semantic-ui-react'


type Props = {
    label: string
    value: string
    onChange: any
} & FormInputProps & InputProps

export const PasswordInput: React.FC<Props> = (props) => {
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    };

    return (
        <div className="relative mb-5 mt-4">
            <Form.Input
                {...props}
                iconPosition='left'
                type={showPassword ? "text" : "password"}
                action={
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="ui icon button"
                     
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                      {showPassword ? (
                        <EyeIcon className="h-5 w-5 text-gray-500 opacity-80 hover:opacity-100 transition duration-100 transform active:scale-90" />
                      ) : (
                        <EyeSlashIcon className="h-5 w-5 text-gray-500 opacity-80 hover:opacity-100 transition duration-100 transform active:scale-90" />
                      )}
                    </button>
                  }
               
               
            />
           

        </div>
    )
}


